import { TransactionType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum } from "class-validator";
import { ForkLiftItemsDto } from "../../fork-lift-items/dto/fork-lift-items.dto";
import { ForkLiftItems } from "../../fork-lift-items/fork-lift-items.entity";
import { ForkJobPurpose } from "./fork-job-purpose.enum";
import { ForkLiftJobStatus } from "./fork-lift-job-status.enum";

export class ForkLiftResponseDto {
    @ApiProperty()
    jobId: number;
    @ApiProperty()
    jobCode: string;
    @ApiProperty()
    transactionTime: Date;
    @ApiProperty({enum:Object.values(ForkLiftJobStatus)})
    @IsNotEmpty()
    @IsEnum(ForkLiftJobStatus)
    status:ForkLiftJobStatus;
    @ApiProperty({enum:Object.values(TransactionType)})
    @IsNotEmpty()
    @IsEnum(TransactionType)
    transactionType:TransactionType;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    message: string;
    @ApiProperty()
    reportedId: number;
    @ApiProperty({ type: [ForkLiftItemsDto]})
    forkLiftItemsInfo: ForkLiftItemsDto[];
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedUser?: string;
    
  }